import React, { Component } from 'react'
import { Button, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap'
import { closeModal } from '../../reducers/modals'

export default class VideoContainer extends Component {
  constructor(props) {
    super(props)

    this.state = Object.assign(
      {
        error: null,
        title: '',
        description: '',
        sectionId: props.sectionId,
        hlsDirectoryURL: '',
        duration: 0,
      },
      props.video || {}
    )
  }

  componentDidMount() {
    this._mounted = true
  }

  componentWillUnmount() {
    this._mounted = false
  }

  onCancel = () => {
    this.props.dispatch(closeModal())
  }

  onFinish = async () => {
    const { json, response } = await this.props.onSave(this.state)
    if (!this._mounted) return false
    if (response.status === 200) {
      this.props.dispatch(closeModal())
    } else {
      this.setState({ error: json.error })
    }
  }

  onDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this video?')) {
      return
    }
    const { json, response } = await this.props.onDelete(this.state)
    if (!this._mounted) return false
    if (response.status === 200) {
      this.props.dispatch(closeModal())
    } else {
      this.setState({ error: json.error })
    }
  }

  render() {
    const verb = this.props.video ? 'Edit' : 'Create a'
    const { error, title, description, hlsDirectoryURL, duration } = this.state

    let valid = title && description && hlsDirectoryURL && duration

    return (
      <div className="VideoModalContainer">
        <ModalHeader toggle={this.onCancel}>{verb} Video</ModalHeader>
        <div className="row">
          <div className="col-md-12">
            <ModalBody>
              {error && <div className="alert alert-danger">{error}</div>}
              <Form>
                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="title">Title</Label>
                    </div>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="text"
                        id="title"
                        value={title}
                        onChange={(e) => this.setState({ title: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="description">Description</Label>
                    </div>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="text"
                        id="description"
                        value={description}
                        onChange={(e) => this.setState({ description: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="hlsDirectoryURL">HLS Directory URL</Label>
                    </div>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="text"
                        id="hlsDirectoryURL"
                        value={hlsDirectoryURL}
                        onChange={(e) => this.setState({ hlsDirectoryURL: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="duration">Duration (Seconds)</Label>
                    </div>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="number"
                        id="duration"
                        value={duration}
                        onChange={(e) => this.setState({ duration: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>
              </Form>
            </ModalBody>
          </div>
        </div>
        <ModalFooter>
          {this.props.onDelete && (
            <Button className="btn btn-danger" onClick={this.onDelete}>
              Delete
            </Button>
          )}
          <div style={{ flex: 1 }} />
          <Button className="btn btn-primary" onClick={this.onFinish} disabled={!valid}>
            Save
          </Button>
        </ModalFooter>
      </div>
    )
  }
}
